import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selectorFamily } from 'recoil';
import { AttendEventRequest, Event, EventAlarmType, EventCore } from '../types/gptTypes';

export const eventsState = atom<PaginatedResponse<EventCore> | undefined>({
  key: 'app.gpt.events',
  default: undefined,
});

export const eventSearchState = atom<string | undefined>({
  key: 'app.gpt.events.search',
  default: undefined,
});

export const eventReloadState = atom<string | undefined>({
  key: 'app.gpt.events.reload',
  default: undefined,
});

export const eventDetailState = atom<Event | undefined>({
  key: 'app.gpt.events.detail',
  default: undefined,
});

export const attendEventFormState = atom<AttendEventRequest>({
  key: 'app.gpt.events.alarm.attend',
  default: {
    code: '',
  },
});

export const attendingEventState = atom<boolean | undefined>({
  key: 'app.gpt.events.alarm.attending',
  default: false,
});

export const gptAlarmTypesState = atom<EventAlarmType[] | undefined>({
  key: 'app.gpt.alarm.types',
  default: undefined,
});

export const gptAlarmTypeState = selectorFamily<EventAlarmType | undefined, number | undefined | null>({
  key: 'app.gpt.alarm.type',
  get:
    (id) =>
    ({ get }) => {
      if (id === null || id === undefined || id === -1) return;
      const alarmTypes = get(gptAlarmTypesState);
      return alarmTypes?.find((alarmType) => alarmType.code === id);
    },
});

export const gptAlarmTypeNameState = selectorFamily<string | undefined, number | undefined | null>({
  key: 'app.gpt.alarm.type.name',
  get:
    (id) =>
    ({ get }) => {
      if (id === null || id === undefined || id === -1) return;
      const alarmTypes = get(gptAlarmTypesState);
      return alarmTypes?.find((alarmType) => alarmType.code === id)?.name ?? id.toString();
    },
});

export const gptAlarmTypeIconsState = atom<{ [key: number]: string } | undefined>({
  key: 'app.gpt.alarm.type.icons',
  default: undefined,
});

export const gptAlarmTypeIconState = selectorFamily<string | undefined, number | null | undefined>({
  key: 'app.gpt.alarm.type.icon',
  get:
    (code) =>
    ({ get }) => {
      if (typeof code != 'number') return;
      return get(gptAlarmTypeIconsState)?.[code];
    },
});
